import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Idea } from '@models/Sessions/Idea/Idea';
import { Session } from '@models/Sessions/Session';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';
import { IdeaRequestService } from '@services/sessions/idea.request.service';

import { IdeaModalComponent } from '../../idea-modal/idea-modal.component';

/**
 * Note (Tim): This component does not work as expected. Replicating old behaviour would involve lots of work
 * and would still be only a short-term solution. This needs to be discussed.
 */
@Component({
  selector: 'app-my-idea-board',
  templateUrl: './idea-board.component.html',
  styleUrls: ['./idea-board.component.scss'],
})
export class SessionModulesIdeaBoardComponent {
  @Input() session: Session;
  @ViewChild('ideaCanvas', { static: true }) ideaCanvas: ElementRef;

  CARD_WIDTH = 190;

  constructor(
    private bus: BusService,
    private events: EventsService,
    private ideaRequest: IdeaRequestService,
    private modalService: NgbModal,
  ) {}

  getPosition(idea: Idea, index: number) {
    if (idea.position) {
      return this.transformed(idea.position, index);
    }

    return {
      x: 0,
      y: 0,
    };
  }

  ideaMoveEnd(event, idea: Idea, index: number) {
    const transformed = this.reverted({ x: event.x, y: event.y }, index);

    const transformedIdea = idea;
    transformedIdea.position = transformed;

    this.bus.publish(
      this.events.requested.action.session.idea.savePosition,
      transformedIdea,
      this.session,
    );
  }

  transformed(coordinates, index: number) {
    const newCoords = { x: coordinates.x, y: coordinates.y };
    if (this.ideaCanvas) {
      const canvasHeight = this.ideaCanvas.nativeElement.clientHeight;

      // We need to multiply this with the card width to get the true position, as the plugin uses relative positions.
      newCoords.y = coordinates.y - canvasHeight;
      newCoords.x = coordinates.x - (0.5 + index * this.CARD_WIDTH);
    }
    return newCoords;
  }

  reverted(coordinates, index) {
    const newCoords = { x: coordinates.x, y: coordinates.y };
    if (this.ideaCanvas) {
      const canvasHeight = this.ideaCanvas.nativeElement.clientHeight;

      newCoords.y = coordinates.y + canvasHeight;
      newCoords.x = coordinates.x + (0.5 + index * this.CARD_WIDTH);
    }
    return newCoords;
  }

  openIdeaModal(idea: Idea) {
    const modalRef = this.modalService.open(IdeaModalComponent, {
      size: 'lg',
      windowClass: 'big-modal',
    });
    (modalRef.componentInstance as IdeaModalComponent).bindData({
      session: this.session,
      idea: idea,
    });
  }
}
